import { DashboardStats, DateFilter } from '../../types';
import { delay } from '../mock/delay';

export const dashboardService = {
  getStats: async (filter: DateFilter, doctorId?: string): Promise<DashboardStats> => {
    await delay(600);
    
    // Mock revenue chart data
    const revenueChart = [
      { time: '07:00', revenue: 0 },
      { time: '08:00', revenue: 50000 },
      { time: '09:00', revenue: 120000 },
      { time: '10:00', revenue: 200000 },
      { time: '11:00', revenue: 560000 },
      { time: '12:00', revenue: 450000 },
      { time: '13:00', revenue: 300000 },
      { time: '14:00', revenue: 400000 },
      { time: '15:00', revenue: 350000 },
      { time: '16:00', revenue: 280000 },
      { time: '17:00', revenue: 200000 },
      { time: '18:00', revenue: 150000 },
      { time: '19:00', revenue: 100000 },
      { time: '20:00', revenue: 80000 },
      { time: '21:00', revenue: 50000 },
      { time: '22:00', revenue: 30000 },
      { time: '23:00', revenue: 0 },
    ];

    return {
      revenue: 5660000,
      services: [
        { name: 'Đơn thuốc quốc gia', quantity: 40, totalAmount: 5240000 },
        { name: 'Xuất hóa đơn điện tử', quantity: 35, totalAmount: 3500000 },
      ],
      revenueChart,
    };
  },
};

